(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enchanted-subscription-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const observedVideos = new WeakSet();
    const initialisedRotators = new WeakSet();
    const initialisedProcessSliders = new WeakSet();
    const initialisedReviewCarousels = new WeakSet();
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        video.muted = true;
        video.defaultMuted = true;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.35 && !prefersReducedMotion.matches) {
          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: [0, 0.35, 1] });

    const initialiseVideos = (root = document) => {
      root.querySelectorAll('.ed-current__video').forEach((video) => {
        if (observedVideos.has(video)) return;
        video.muted = true;
        video.defaultMuted = true;
        observedVideos.add(video);
        observer.observe(video);
      });
    };

    const initialiseRotators = (root = document) => {
      root.querySelectorAll('[data-ed-hero-rotator]').forEach((rotator) => {
        if (initialisedRotators.has(rotator)) return;
        const frames = Array.from(rotator.querySelectorAll('.ed-hero-rotator__frame'));
        if (frames.length < 2) return;
        initialisedRotators.add(rotator);
        let activeIndex = Math.max(0, frames.findIndex((frame) => frame.classList.contains('is-active')));
        let timer;
        const interval = Number(rotator.dataset.interval) || 4000;
        frames.forEach((frame, index) => frame.classList.toggle('is-active', index === activeIndex));
        const stop = () => {
          window.clearInterval(timer);
          timer = undefined;
        };
        const start = () => {
          if (timer) return;
          timer = window.setInterval(() => {
            frames[activeIndex].classList.remove('is-active');
            activeIndex = (activeIndex + 1) % frames.length;
            frames[activeIndex].classList.add('is-active');
          }, interval);
        };
        start();
        const visibilityObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) start();
            else stop();
          });
        }, { threshold: 0.2 });
        visibilityObserver.observe(rotator);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) stop();
          else start();
        });
      });
    };

    const initialiseProcessSliders = (root = document) => {
      root.querySelectorAll('[data-ed-process-slider]').forEach((slider) => {
        if (initialisedProcessSliders.has(slider)) return;
        const cards = Array.from(slider.querySelectorAll('.ed-process__step'));
        const section = slider.closest('.ed-process');
        const current = section ? section.querySelector('[data-ed-process-current]') : null;
        if (!current || cards.length < 2) return;
        initialisedProcessSliders.add(slider);
        let frame;
        const updateCurrent = () => {
          frame = undefined;
          let closestIndex = 0;
          let closestDistance = Infinity;
          cards.forEach((card, index) => {
            const distance = Math.abs(card.offsetLeft - slider.scrollLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          current.textContent = String(closestIndex + 1);
        };
        slider.addEventListener('scroll', () => {
          if (frame) return;
          frame = window.requestAnimationFrame(updateCurrent);
        }, { passive: true });
        updateCurrent();
      });
    };

    const initialiseReviewCarousels = (root = document) => {
      root.querySelectorAll('[data-ed-review-carousel]').forEach((carousel) => {
        if (initialisedReviewCarousels.has(carousel)) return;
        if (carousel.dataset.edReviewInlineReady === 'true') return;
        const viewport = carousel.querySelector('[data-ed-review-viewport]');
        const cards = Array.from(carousel.querySelectorAll('[data-ed-review-card]'));
        if (!viewport || cards.length === 0) return;
        initialisedReviewCarousels.add(carousel);
        let activeIndex = 0;
        let frame;
        const setActive = (index) => {
          activeIndex = Math.max(0, Math.min(index, cards.length - 1));
          cards.forEach((card, cardIndex) => card.classList.toggle('is-active', cardIndex === activeIndex));
        };
        const scrollToCard = (index, immediate = false) => {
          const card = cards[Math.max(0, Math.min(index, cards.length - 1))];
          const viewportBox = viewport.getBoundingClientRect();
          const cardBox = card.getBoundingClientRect();
          const left = viewport.scrollLeft + cardBox.left - viewportBox.left - ((viewport.clientWidth - card.offsetWidth) / 2);
          viewport.scrollTo({ left, behavior: immediate || prefersReducedMotion.matches ? 'auto' : 'smooth' });
        };
        const updateActive = () => {
          frame = undefined;
          const centre = viewport.scrollLeft + (viewport.clientWidth / 2);
          let closestIndex = 0;
          let closestDistance = Infinity;
          cards.forEach((card, index) => {
            const distance = Math.abs((card.offsetLeft + (card.offsetWidth / 2)) - centre);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          setActive(closestIndex);
        };
        viewport.addEventListener('scroll', () => {
          if (frame) return;
          frame = window.requestAnimationFrame(updateActive);
        }, { passive: true });
        const requestedStartingIndex = Number(carousel.dataset.edReviewStartIndex) || 0;
        const startingIndex = window.innerWidth > 900 ? 0 : Math.min(requestedStartingIndex, cards.length - 1);
        const mobileMedia = window.matchMedia('(max-width: 560px)');
        const syncMobileLayout = () => {
          if (mobileMedia.matches) {
            const cardWidth = Math.round(viewport.clientWidth * 0.76);
            const sideSpace = Math.round((viewport.clientWidth - cardWidth) / 2);
            carousel.style.setProperty('--ed-review-card-width-mobile', `${cardWidth}px`);
            carousel.style.setProperty('--ed-review-side-mobile', `${sideSpace}px`);
          } else {
            carousel.style.removeProperty('--ed-review-card-width-mobile');
            carousel.style.removeProperty('--ed-review-side-mobile');
          }
        };
        const positionCard = (index) => {
          syncMobileLayout();
          if (window.innerWidth > 900) {
            viewport.scrollTo({ left: cards[index].offsetLeft - cards[0].offsetLeft, behavior: 'auto' });
          } else if (mobileMedia.matches && index > 0) {
            viewport.scrollTo({ left: cards[index].offsetLeft - cards[0].offsetLeft, behavior: 'auto' });
          } else {
            scrollToCard(index, true);
          }
        };
        setActive(startingIndex);
        syncMobileLayout();
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => positionCard(startingIndex));
        });
        window.setTimeout(() => positionCard(startingIndex), 180);
        if ('ResizeObserver' in window) {
          let resizeFrame;
          const resizeObserver = new ResizeObserver(() => {
            window.cancelAnimationFrame(resizeFrame);
            resizeFrame = window.requestAnimationFrame(() => positionCard(activeIndex));
          });
          resizeObserver.observe(viewport);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initialiseVideos();
        initialiseRotators();
        initialiseProcessSliders();
        initialiseReviewCarousels();
      });
    } else {
      initialiseVideos();
      initialiseRotators();
      initialiseProcessSliders();
      initialiseReviewCarousels();
    }
    document.addEventListener('shopify:section:load', (event) => {
      initialiseVideos(event.target);
      initialiseRotators(event.target);
      initialiseProcessSliders(event.target);
      initialiseReviewCarousels(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
